import {
  AddChatsToGroupsPayload,
  AddNewChatPayload,
  AddVideoCallInRoomPayload,
  ChatListActions,
  FetchMoreResultPayload,
  OverwriteNotificationsPayload,
  UpdateChatInfoPayload,
  UpdateChatToTopPayload,
  UpdateChatWithNotificationPayload,
  UpdateLastViewedMessageInChatPayload,
} from './chatListReducer.types';

export const fetchingMore = (): ChatListActions => ({ type: 'FETCHING_MORE' });

export const fetchMoreResult = (payload: FetchMoreResultPayload): ChatListActions => ({
  type: 'FETCH_MORE_RESULT',
  payload,
});

export const errorFetchingGroups = (): ChatListActions => ({
  type: 'ERROR_FETCHING_GROUPS',
});

export const addNewChat = (payload: AddNewChatPayload): ChatListActions => ({
  type: 'ADD_NEW_CHAT',
  payload,
});

export const updateChatToTop = (payload: UpdateChatToTopPayload): ChatListActions => ({
  type: 'UPDATE_CHAT_TO_TOP',
  payload,
});

export const updateChatWithNotification = (
  payload: UpdateChatWithNotificationPayload,
): ChatListActions => ({
  type: 'UPDATE_CHAT_WITH_NOTIFICATION',
  payload,
});

export const resetState = (): ChatListActions => ({ type: 'RESET_STATE' });

export const addVideoCallInRoom = (payload: AddVideoCallInRoomPayload): ChatListActions => ({
  type: 'ADD_VIDEO_CALL_IN_ROOM',
  payload,
});

export const overwriteNotifications = (
  payload: OverwriteNotificationsPayload,
): ChatListActions => ({
  type: 'OVERWRITE_NOTIFICATIONS',
  payload,
});

export const updateLastViewedMessageInChat = (
  payload: UpdateLastViewedMessageInChatPayload,
): ChatListActions => ({
  type: 'UPDATE_LAST_VIEWED_MESSAGE_IN_CHAT',
  payload,
});

export const addChatsToGroup = (payload: AddChatsToGroupsPayload): ChatListActions => ({
  type: 'ADD_CHATS_TO_GROUPS',
  payload,
});

export const updateChatInfo = (payload: UpdateChatInfoPayload): ChatListActions => ({
  type: 'UPDATE_CHAT_INFO',
  payload,
});
